<mat-list cdkDropList (cdkDropListDropped)="drop($event)">
  <mat-list-item
    *ngFor="let item of itemsSelected; let last = last; let index = index"
    cdkDrag
  >
    <div class="dd-placeholder" *cdkDragPlaceholder></div>
    <mat-checkbox
      [(ngModel)]="item.selected"
      (change)="checkboxChange($event, item)"
    ></mat-checkbox>
    <div matLine [class.select]="item.selected">
      <span class="badge selected">
        {{ index + 1 }}
      </span>
      {{ item.item.label }}
    </div>
  </mat-list-item>
</mat-list>
<mat-divider
  *ngIf="itemsUnselected.length !== 0 && itemsSelected.length !== 0"
></mat-divider>
<mat-list>
  <mat-list-item
    *ngFor="let item of itemsUnselected; let last = last; let index = index"
  >
    <mat-checkbox
      [(ngModel)]="item.selected"
      (change)="checkboxChange($event, item)"
    ></mat-checkbox>
    <div matLine [class.select]="item.selected">
      <span class="badge">- </span>
      {{ item.item.label }}
    </div>
  </mat-list-item>
</mat-list>
